
import React from 'react';
import {reduxForm} from 'redux-form';
import get from 'lodash/get';
import cs from 'classnames';
import {connect} from 'react-redux';
import startOfDay from 'date-fns/start_of_day';
import isEmpty from 'lodash/isEmpty';

// import {form2query, query2form} from '../../misc/search';
import LocationInput2 from '~/components/common/LocationInput2';
import MultipleSelect from '~/components/common/MultipleSelect';
import LabeledInput from '~/components/common/LabeledInput';
import DoubleSizeSelect from '~/components/common/DoubleSizeSelect';
import CalendarInput from '~/components/common/CalendarInput';
import WeightInput from '~/components/common/weightInput/index.js';
import LengthInput from '~/components/common/LengthInput/index.js';
import EquipSelect from '~/components/common/EquipSelect';
import {errorInfoConfig} from '~/misc/error-info';

import addCss from './index.css';
import mapDispatch from '~/misc/mapDispatch';
import config from '~/config';
import css from '~/components/searchform/searchform.css';

const isDeadHeadApplicable = (state, id, type) => {
  let value;
  if (type === 'destination') {
    value = get(state, ['geosearch', id, 'selected', 0, 'placeValue']);
  } else {
    value = get(state, ['geosearch', id, 'placeValue']);
  }
  return get(value, 'is_city') || get(value, 'is_other');
};

const locationInputId = (props, name) => `${props.id}:${name}`;

// 初始化表单
const initForm = (data) => {
  let result = {
    ...data,
    date: data.date || [startOfDay(new Date())],
    loadSize: data.loadSize || 'FTL',
    equipment: data.equipment || ['F']
  }
  return result;
}

class addForm extends React.Component {
  constructor(props){
    super(props);
    this.state={
      formData: '',
      formError: '',
    };
    this.subMit = this.subMit.bind(this);
    this.placeHandleChange = this.placeHandleChange.bind(this);
    this.placeHandleBlur = this.placeHandleBlur.bind(this);
    this.deadheadHandleBlur = this.deadheadHandleBlur.bind(this);
  }
  componentWillMount(){
    this.setState({
      formData: Object.assign({}, this.state.formData, {
        origin: {
          name: this.props.fields.origin.value || ''
        },
      }),
    })
  }
  render(){
    let props = this.props;
    const inputsOptions = {
      isWhiteLabel: props.isLandingForm || props.isHugeShortForm,
      tallInput: props.isLandingForm,
      hugeInput: props.isHugeShortForm,
    };
    const isHugeShortForm = props.isHugeShortForm || null;
    return (
      <div className={cs(addCss.addForumWrapper)}>
        <form
          // onSubmit={props.handleSubmit}
          className={cs(addCss.formWrapper, {[css.usualForm]: !isHugeShortForm})} data-qa='alert-form' noValidate>
        <div>
          <div className={addCss.inputRow}>
            <div
              className={addCss.placeInputGroup}
            >
              <LocationInput2
                input={inputsOptions}
                {...props.fields.origin}
                id={locationInputId(props, 'origin-field')}
                name='origin'
                data-qa='origin'
                label='Origin'
                onChange={(param) => this.placeHandleChange(param)}
                onBlur={(param) => this.placeHandleBlur(param)}
                placeholder={get(props, 'placeholders.origin')}
                autoComplete='off'
                touched={true}
                error={this.state.formError.origin}
              />
              {!isHugeShortForm && <LabeledInput
                {...inputsOptions}
                label='Deadhead,mi'
                type='number'
                mediumInput
                {...props.fields.dho}
                onBlur={() => this.deadheadHandleBlur('dho')}
                data-qa='dho-field'
                placeholder={get(props, 'placeholders.dho') || (props.isDHOApplicable ? '200' : '')}
                touched={true}
                error={this.state.formError.dho}
              />}
            </div>
            {!isHugeShortForm && <div className={addCss.placeInputGroup}>
              {<MultipleSelect
                {...props.fields.destination}
                input={{...inputsOptions, mediumInput: true}}
                id={locationInputId(props, 'destination-field')}
                name='destination'
                data-qa='destination'
                label='Destination'
                onChange={(param) => this.placeHandleChange(param)}
                onBlur={(param) => this.placeHandleBlur(param)}
                placeholder={get(props, 'placeholders.destination')}
                autoComplete='off'
              />}
              <LabeledInput
                {...inputsOptions}
                label='Deadhead,mi'
                type='number'
                mediumInput
                {...props.fields.dhd}
                onBlur={() => this.deadheadHandleBlur('dhd')}
                data-qa='dhd-field'
                placeholder={get(props, 'placeholders.dhd') || (props.isDHDApplicable ? '200' : '')}
                touched={true}
                error={this.state.formError.dhd}
              />
            </div>}
          </div>
          <div className={cs(addCss.inputRow, addCss.marginTop)}>
            <CalendarInput
                input={inputsOptions}
                {...props.fields.date}
                data-qa='pickup'
                label='Pickup Date'
                multiSelect={true}
                withoutAny
                wrapClassName={cs(addCss.miniInput, {
                  [css.hugePickup]: isHugeShortForm,
                })}
                dropDownId='datePickup'
              />
          </div>
          <div className={cs(addCss.inputRow, addCss.marginTop)}>
            <DoubleSizeSelect {...props.fields.loadSize}  input={{...inputsOptions, mediumInput: true}}  wrapClassName={addCss.miniInput} dropDownId='sizeSelect'/>
            <EquipSelect
              limit={1}
              {...props.fields.equipment}
              wrapClassName={cs(addCss.miniInput, {
                [css.hugeEquip]: isHugeShortForm,
              })}
              withoutAny
              label="Trailer Type"
              dropDownId='equipmentAlert'
              data-qa='equipmentAlert'
            />
            <WeightInput {...props.fields.weight}  input={{...inputsOptions, mediumInput: true , wrapClassName :  addCss.miniInput}}/>
            <LengthInput {...props.fields.length}  input={{...inputsOptions, mediumInput: true , wrapClassName :  addCss.miniInput}}/>
          </div>
        </div>
        <div className={cs(addCss.buttonWrapper)}>
          <button onClick={this.subMit} className={cs(addCss.alterButton)}>{props.buttonInfo}</button>
        </div>
      </form>
      </div>
    )
  }
  placeHandleChange(param) {
    this.setState({
      formData: Object.assign({}, this.state.formData, {
        [param.name]: param.data.placeValue
      }),
      formError: Object.assign({}, this.state.formError, {
        [param.name]: ''
      }),
    });
  }

  placeHandleBlur(param) {
    let errorMsg = '';
    if (!param.data.placeValue || !param.data.placeValue.name || isEmpty(param.data.placeValue)) {
      errorMsg = 'Origin is required.';
    } else if (param.data.placeValue.name.indexOf(',') === -1 && !param.data.placeValue.is_city || param.data.placeValue.is_other) {
      errorMsg = errorInfoConfig.placeInput.wrong;
    }

    this.setState({
      formData: Object.assign({}, this.state.formData, {
        [param.name]: param.data.placeValue
      }),
      formError: Object.assign({}, this.state.formError, {
        [param.name]: errorMsg
      }),
    });
  }

  deadheadHandleBlur (param) {
    const fleid = this.props.fields[param]
    let error = ''
    if(fleid.value - 200 > 0) error = "Limit 200 mi"
    this.setState({
      formError: Object.assign({}, this.state.formError, {
        [fleid.name]: error
      }),
    });
  }
  pickupTimeHandleBlur = (param) => {
    console.log(param);
  } 
  
  subMit(e) {
    e.preventDefault();
    if (!this.state.formData.origin || !this.state.formData.origin.name || isEmpty(this.state.formData.origin)) {
      return this.setState({
        formError: Object.assign({}, this.state.formError, {
          origin: 'Origin is required.'
        }),
      });
    } else if (this.state.formData.origin.name.indexOf(', ') === -1) {
      return this.setState({
        formError: Object.assign({}, this.state.formError, {
          origin: errorInfoConfig.placeInput.wrong
        }),
      });
    } else if (this.props.fields.dho.value - 200 > 0) {
      return this.setState({
        formError: Object.assign({}, this.state.formError, {
          dho: 'Limit 200 mi'
        }),
      });
    } else if (this.props.fields.dhd.value - 200 > 0) {
      return this.setState({
        formError: Object.assign({}, this.state.formError, {
          dhd: 'Limit 200 mi'
        }),
      });
    } else if (this.props.fields.length.value - 100 >= 0) {
      return this.setState({
        formError: Object.assign({}, this.state.formError, {
          length: 'Length is over limit.'
        }),
      });
    }
    this.props.submit(this.props.values);
  }
}

const fields = [
  'origin',
  'dho',
  'destination',
  'dhd',
  'date',
  'loadSize',
  'weight',
  'length',
  'equipment'
];

const reduxedForm = reduxForm(
  {
    form: 'alert',
    id: 'alert',
    fields,
    validate:(value, props) => {
      const errors = {};
      if (value.length && (value.length >= 100 || value.length < 1)) {
        errors.length = 'Length is over limit.';
      }
      return errors;
    }
  },
  (state, props) => ({
    anonBanerTextAndAction: config.anonBanerTextAndAction,
    initialValues: initForm(props.initData),
    isDHOApplicable: isDeadHeadApplicable(state, locationInputId(props, 'origin-field')),
    isDHDApplicable: isDeadHeadApplicable(state, locationInputId(props, 'destination-field'), 'destination'),
    userIsLoggedIn: state.user.isLoggedIn,
  })
)(addForm)

export default connect(({alert}) => ({
  initData: alert.initForm
}), mapDispatch({
  onSubmit: (props, formData) => props.submit(formData),
}))(reduxedForm);



// WEBPACK FOOTER //
// ./src/components/common/AlertForm/index.js